import React from "react"
import { Chip, FontIcon, IconButton, TextField } from "material-ui"
import autobind from "class-autobind"

interface IProps {
  title: string
  titleStyle: React.CSSProperties
  chipStyle: React.CSSProperties
  addButtonStyle: React.CSSProperties
  allData: String[]
  error: string
  handleChange(allData: String[]): void
  handleSnackbarAlertContent(snackbarAlertContent: string): void
  onChange(key, value): void
}
interface IState {
    openText: boolean;
    value: string;
  }
  
  export default class TextChip extends React.Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = {
        openText: false,
        value: "",
      };
      autobind(this);
    }
  
    handleDelete(data) {
      const newData = this.props.allData.slice().filter((item) => item !== data);
      this.props.handleChange(newData);
    }
  
    handleAdd() {
      if (this.state.value) {
        const newData = this.props.allData.slice();
        newData.push(this.state.value);
        this.props.handleChange(newData);
        this.setState({ value: "", openText: false });
      }
    }
  
    handleChange(event) {
      this.setState({ value: event.target.value });
    }
  
    render() {
      return (
        <div style={{ position: "relative" }}>
          <span style={this.props.titleStyle}>{this.props.title}</span>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {this.props.allData.map((data, index) => (
              <Chip
                key={index}
                onRequestDelete={() => this.handleDelete(data)}
                style={this.props.chipStyle}
              >
                {data}
              </Chip>
            ))}
            <div style={this.props.addButtonStyle}>
              {!this.state.openText && (
                <IconButton
                  data-intercom-target={"Btn-OpenDatePicker"}
                  onTouchTap={() => this.setState({ openText: true })}
                >
                  <FontIcon className="fa fa-plus-circle" />
                </IconButton>
              )}
            </div>
          </div>
          {this.props.error && !this.state.openText && (
            <div
              style={{
                position: "absolute",
                bottom: -20,
                fontSize: 12,
                color: "rgb(244, 67, 54)",
                transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
              }}
            >
              {this.props.error}
            </div>
          )}
          {this.state.openText && (
            <TextField
              floatingLabelText={this.props.title}
              value={this.state.value}
              style={{ width: 400 }}
              onChange={(e) => this.handleChange(e)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.handleAdd();
                }
              }}
              onBlur={() => this.handleAdd()}
            />
          )}
        </div>
      );
    }
  }